module.exports = __webpack_public_path__ + "media/images/categories/carousel/education-and-corporate-training-44360553dcba95adb9a617ed4a4c64ff.jpg";